import { render, staticRenderFns } from "./DefaultText.vue?vue&type=template&id=7708554e"
import script from "./DefaultText.vue?vue&type=script&lang=js"
export * from "./DefaultText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports